<!--begin::Tables Widget 11-->
<div class="card mb-5 mb-xl-8 border rounded">
  <!--begin::Header-->
  <div class="card-header border-0 pt-5">
    <h3 class="card-title align-items-start flex-column">
      <span class="card-label fw-bolder fs-3 mb-1">{{header}}</span>
    </h3>
  </div>
  <!--end::Header-->
  <!--begin::Body-->
  <div class="card-body py-3">
    <!-- Query container: the table→cards reflow (see scss) keys off THIS element's width, so it works in
         any embedding context (narrow preview OR compact editor) without the parent reaching in. -->
    <div class="field-config">
    <!--begin::Table container-->
    <div class="table-responsive">
      <!--begin::Table-->
      <table class="table align-middle gs-0 gy-4">
        <!--begin::Table head-->
        <thead>
          <tr class="fw-bolder text-muted bg-light">
            <th class="ps-4 rounded-start">Name</th>
            <th>Display Name</th>
            <th>Required</th>
            <th>Hidden</th>
          </tr>
        </thead>
        <!--end::Table head-->
        <!--begin::Table body-->
        <tbody>
          @for (fieldConfig of fieldConfigs; track fieldConfig.name) {
            <tr>
              <td>
                <div class="d-flex align-items-center">
                  <div class="d-flex justify-content-start flex-column">
                    <span class="text-dark fw-bolder mb-1 fs-6">{{fieldConfig.name}}</span>
                  </div>
                </div>
              </td>
              <td data-label="Display Name">
                <div class="d-flex justify-content-start flex-column">
                  <input [ngModel]="i18n.get(fieldConfig, 'displayName')"
                    (ngModelChange)="i18n.set(fieldConfig, 'displayName', $event)"
                    [placeholder]="i18n.basePlaceholder(fieldConfig, 'displayName')"
                    class="form-control" id="{{fieldConfig.name}}" name="{{fieldConfig.name}}">
                </div>
              </td>
              <td data-label="Required">
                <div class="form-check form-switch form-check-custom form-check-solid me-10">
                  <input class="form-check-input h-20px w-30px" type="checkbox" [(ngModel)]="fieldConfig.isRequired"/>
              </div>
              </td>
              <td data-label="Hidden">
                <div class="form-check form-switch form-check-custom form-check-solid me-10">
                  <input class="form-check-input h-20px w-30px" type="checkbox" [(ngModel)]="fieldConfig.isHidden"/>
              </div>
              </td>
            </tr>
          }
        </tbody>
        <!--end::Table body-->
      </table>
      <!--end::Table-->
    </div>
    <!--end::Table container-->
    </div>
    <!--end::field-config query container-->
  </div>
  <!--begin::Body-->
</div>
<!--end::Tables Widget 11-->
